import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/chat/material/examples/basic-ai-chat/basic-ai-chat.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
